export const BOOLEAN = 'boolean';
export const DATE = 'date';
export const DOUBLE = 'double';
export const GEO_LOCATION = 'geo_location';
export const LONG = 'long';
export const OBJECT = 'object';
export const STRING = 'string';
export const CAMPAIGN_LABEL = 'campaignLabelId';
export const NESTED = 'nested';
export const KEYWORD = 'keyword';

export const LIST_TYPE_FIELDS = ['emailListIds', 'emailListId', 'templateId', 'canonicalUrlId'];
export const CAMPAIGN_LABEL_TYPE_FIELDS = [CAMPAIGN_LABEL];
